import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';

export default async function deleteActionApi(
  action,
) {
  try {
    const _ret = await axiosInstance({
      url: `${urlBaseAccreditation}/action/deleteAction`,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        id: action.id,
        eventId: parseInt(action.eventId),
        apiType: 'inteegra',
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return;

  } catch (error) {
    console.log('Error deleteActionApi', error);
    throw error;
  }
}
